// extracted by mini-css-extract-plugin
export default {"iframe":"WebPageUrlModal__iframe__nmqnl"};